<template>
  <div class="modal to-top" :class="{ 'is-active': active }">
      <div class="modal-background"></div>
      <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">{{ $t("MobileMoney") }}</p>
          </header>
          <section class="modal-card-body has-text-centered">
            <div class="card">
                <div class="card-content">
                    <template v-if="step == 1">
                        <p v-for="line in lines" :key="line.id" class="has-text-centered padding-bottom-1rem" v-html="line"></p>
                    </template>
                    <template v-if="step == 2">
                        <p class="has-text-centered">{{ $t("ThankYourForYourPurchase") }}</p>
                    </template>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-centered">
          <template v-if="step == 1 && user.countryID != 13">
            <a @click="close()" class="button is-info is-fullwidth">
                <span class="icon">
                    <i class="fa fa-times"></i>
                </span>
                <span>{{ $t("Close") }}</span>
            </a>
          </template>
        </footer>
      </div>
  </div>
</template>

<script>
export default {
  name: "MobileMoneyModal",
  props: {
    active: Boolean
  },
  mounted: function()
  {
    this.lines = this.$t("MobileMoneyBody").split("\\n");
  },
  data()
  {
      return {
          step: 1,
          lines: []
      }
  },
  methods:
  {
      close: function()
      {
          this.$parent.paymentMethod = "disabled";
      },
      next: function()
      {
          this.step = 2;
      }
  }
};
</script>